<template>
  <div id="contenedor-main-expediente" class="bkground">
    <!-- Estado cargando -->
    <template v-if="$apollo.loading">
      <v-skeleton-loader type="card" height="80" class="rounded-lg mb-4" />
      <v-skeleton-loader type="table" class="rounded-lg" />
    </template>

    <!-- Contenido -->
    <template v-else>
      <!-- Estado vacío: No hay expediente -->
      <template v-if="!getExistenDocumentos">
        <v-row justify="center">
          <v-col cols="12" md="6">
            <v-card class="rounded-lg text-center py-10">
              <v-icon size="80" color="grey lighten-1">
                mdi-folder-open-outline
              </v-icon>
              <h2 class="grey--text text--darken-1 mt-4">
                No hay expediente creado
              </h2>
              <p class="grey--text mt-2 px-8">
                Crea el expediente para comenzar a integrar
                los documentos del contrato
              </p>
              <v-btn
                v-if="mixValidaScopesActions(1)"
                color="primary"
                class="mt-4"
                @click="mostrarCrearExpediente = true">
                <v-icon left>mdi-plus</v-icon>
                Crear Expediente
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- Expediente existe -->
      <template v-else>
        <!-- Barra de estadísticas horizontal -->
        <v-card class="rounded-lg mb-4">
          <v-card-text class="py-3">
            <v-row align="center" no-gutters>
              <!-- Estadísticas compactas -->
              <v-col cols="auto" class="d-flex align-center">
                <div class="d-flex align-center mr-6">
                  <v-avatar size="36" color="primary" class="mr-2">
                    <span class="white--text text-subtitle-2">
                      {{ getEstadisticas.documentosTotales }}
                    </span>
                  </v-avatar>
                  <span class="text-caption grey--text">Total</span>
                </div>

                <div class="d-flex align-center mr-6">
                  <v-avatar size="36" color="warning" class="mr-2">
                    <span class="white--text text-subtitle-2">
                      {{ getEstadisticas.documentosAplican }}
                    </span>
                  </v-avatar>
                  <span class="text-caption grey--text">Aplican</span>
                </div>

                <div class="d-flex align-center mr-6">
                  <v-avatar size="36" color="success" class="mr-2">
                    <span class="white--text text-subtitle-2">
                      {{ getEstadisticas.documentosIntegrados }}
                    </span>
                  </v-avatar>
                  <span class="text-caption grey--text">Integrados</span>
                </div>

                <div class="d-flex align-center mr-6">
                  <v-avatar
                    size="36"
                    :color="getEstadisticas.documentosFaltantes === 0
                      ? 'success' : 'error'"
                    class="mr-2">
                    <span class="white--text text-subtitle-2">
                      {{ getEstadisticas.documentosFaltantes }}
                    </span>
                  </v-avatar>
                  <span class="text-caption grey--text">Faltantes</span>
                </div>
              </v-col>

              <v-divider vertical class="mx-4" />

              <!-- Progreso -->
              <v-col cols="auto" class="d-flex align-center" style="min-width: 200px;">
                <div class="flex-grow-1 mr-3">
                  <div class="d-flex justify-space-between mb-1">
                    <span class="text-caption grey--text">Progreso</span>
                    <span class="text-caption font-weight-bold">
                      {{ getPorcentajeIntegracion.toFixed(0) }}%
                    </span>
                  </div>
                  <v-progress-linear
                    :value="getPorcentajeIntegracion"
                    :color="getColorProgreso"
                    height="8"
                    rounded />
                </div>
                <v-chip small :color="getColorProgreso" text-color="white">
                  {{ getTextoEstadoExpediente }}
                </v-chip>
              </v-col>

              <v-spacer />

              <!-- Acciones -->
              <v-col cols="auto">
                <v-btn
                  outlined
                  small
                  color="primary"
                  :loading="mostrarDescargando"
                  @click="descargarExpediente">
                  <v-icon left small>mdi-download</v-icon>
                  Descargar Expediente
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Tabla de documentos (ancho completo) -->
        <v-card class="rounded-lg">
          <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
            <v-icon left small color="white">mdi-file-document-multiple</v-icon>
            Documentos del Expediente
            <v-chip x-small color="white" text-color="grey darken-3" class="ml-2">
              {{ getDocumentosExpedienteContrato.length }}
            </v-chip>
            <v-spacer />

            <!-- Búsqueda en header -->
            <v-text-field
              v-model="buscarTexto"
              placeholder="Buscar..."
              prepend-inner-icon="mdi-magnify"
              clearable
              dense
              solo
              flat
              hide-details
              dark
              background-color="grey darken-2"
              class="mr-3"
              style="max-width: 250px;" />

            <v-btn
              v-if="mixValidaScopesActions(1)"
              small
              color="white"
              text
              @click="agregarDocumentoExpediente">
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-0">
            <listado
              :listadoDocumentosExpedienteContrato="getDocumentosExpedienteContrato"
            />
          </v-card-text>
        </v-card>
      </template>
    </template>

    <!-- Diálogo Crear Expediente -->
    <v-dialog
      v-if="mostrarCrearExpediente"
      v-model="mostrarCrearExpediente"
      width="1500"
      persistent>
      <crear-expediente
        :idReferencia="idReferencia"
        :moduloExpedienteOrigen="moduloExpedienteOrigen"
        :catalogoExpediente="getCatalogoExpediente"
        :comoSeContrato="getContrato.comoSeContrato"
        v-on:cerrar="cerrarVentana">
      </crear-expediente>
    </v-dialog>

    <!-- Diálogo Agregar Documento -->
    <v-dialog
      v-if="mostrarAgregarDocumentoExpediente"
      v-model="mostrarAgregarDocumentoExpediente"
      width="1200"
      persistent>
      <agregar-documento-expediente
        :idReferencia="idReferencia"
        :moduloExpedienteOrigen="moduloExpedienteOrigen"
        :catalogoExpediente="getCatalogoExpediente"
        :expedientePorContrato="getDocumentosExpedienteContrato"
        :contrato="getContrato"
        v-on:cerrar="cerrarVentana">
      </agregar-documento-expediente>
    </v-dialog>

    <!-- Diálogo Editar Documento -->
    <v-dialog
      v-if="esteDocumentoExpediente"
      v-model="mostrarEditarDocumentoExpediente"
      width="1200"
      persistent>
      <editar-documento-expediente
        :expedienteDocumentoEditar="esteDocumentoExpediente"
        v-on:cerrar="cerrarVentana">
      </editar-documento-expediente>
    </v-dialog>

    <!-- Diálogo Eliminar Documento -->
    <v-dialog
      v-if="esteDocumentoExpediente"
      v-model="mostrarEliminarDocumetoExpediente"
      width="500"
      persistent>
      <eliminar-documento-expediente
        :documentoExpedienteEliminar="esteDocumentoExpediente"
        :idReferenciaExpedienteDocumento="idReferencia"
        v-on:cerrar="cerrarVentana">
      </eliminar-documento-expediente>
    </v-dialog>

    <!-- Diálogo Ver Documento -->
    <v-dialog
      v-if="esteDocumentoExpediente"
      v-model="mostrarVerDocumentoExpediente"
      width="1200"
      scrollable>
      <v-card class="rounded-lg">
        <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
          <v-icon left small color="white">mdi-file-eye</v-icon>
          Vista Previa del Documento
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="cerrarVentana">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <ver-documento-pdf
            :documentoPdfVer="esteDocumentoExpediente"
            :moduloOrigen="moduloExpedienteOrigen"
            v-on:cerrar="cerrarVentana">
          </ver-documento-pdf>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo Descargando -->
    <v-dialog
      v-if="progresoDescarga"
      v-model="mostrarDescargando"
      width="300"
      persistent>
      <v-card class="rounded-lg text-center pa-6">
        <v-icon size="40" color="primary" class="mb-4">mdi-folder-download</v-icon>
        <h3 class="grey--text text--darken-2 mb-4">
          Descargando expediente...
        </h3>
        <v-progress-circular
          :size="80"
          :width="8"
          :value="progresoDescarga"
          color="primary">
          <span class="text-h6 font-weight-bold">{{ progresoDescarga }}%</span>
        </v-progress-circular>
        <p class="text-caption grey--text mt-4 mb-0">
          {{ getContrato.numero }}
        </p>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EXPEDIENTE_POR_CONTRATO from '@/graphql/querys/administracion/expediente/expedientePorContrato.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CATALOGO_EXPEDIENTE from '@/graphql/querys/administracion/catalogos/expedientes/catalogoExpediente.gql';
import EditarDocumentoExpediente from '@/components/administracion/expedientes/documentos/Editar.vue';
import AgregarDocumentoExpediente from '@/components/administracion/expedientes/documentos/Agregar.vue';
import EliminarDocumentoExpediente from '@/components/administracion/expedientes/documentos/Eliminar.vue';
import verDocumentoPdf from '@/components/VistaDocumentoPdf.vue';
import CrearExpediente from '@/components/administracion/expedientes/CrearExpediente.vue';
import eventBus from '@/helpers/eventBus';
import mixDescargarArchivo from '@/helpers/mixDescargarArchivo';
import Listado from './listado/Main.vue';

export default {
  name: 'ExpedienteMain',
  mixins: [mixDescargarArchivo],
  props: {
    idReferencia: {
      type: String,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
    tipoLista: {
      type: Boolean,
      required: false,
      default: true,
    },
    moduloExpedienteOrigen: {
      type: String,
      required: true,
    },
  },
  components: {
    Listado,
    AgregarDocumentoExpediente,
    EditarDocumentoExpediente,
    EliminarDocumentoExpediente,
    verDocumentoPdf,
    CrearExpediente,
  },
  data() {
    return {
      mostrarCrearExpediente: false,
      mostrarAgregarDocumentoExpediente: false,
      mostrarEditarDocumentoExpediente: false,
      mostrarEliminarDocumetoExpediente: false,
      mostrarVerDocumentoExpediente: false,
      mostrarDescargando: false,
      progresoDescarga: null,
      esteDocumentoExpediente: null,
      buscarTexto: '',
    };
  },
  apollo: {
    expedientePorContrato: {
      query: EXPEDIENTE_POR_CONTRATO,
      variables() {
        return {
          idContrato: this.idReferencia,
        };
      },
    },
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.idReferencia,
        };
      },
    },
    catalogoExpediente: {
      query: CATALOGO_EXPEDIENTE,
    },
  },
  methods: {
    cerrarVentana() {
      this.mostrarAgregarDocumentoExpediente = false;
      this.mostrarEditarDocumentoExpediente = false;
      this.mostrarEliminarDocumetoExpediente = false;
      this.mostrarVerDocumentoExpediente = false;
      this.mostrarCrearExpediente = false;
      this.mostrarDescargando = false;
      this.esteDocumentoExpediente = null;
      this.progresoDescarga = null;
    },
    agregarDocumentoExpediente() {
      this.mostrarAgregarDocumentoExpediente = true;
    },
    descargarExpediente() {
      if (this.getSoloPublicKeys.length === 0) {
        this.mixMensajeError('No se encontraron documentos para descargar.');
        return;
      }
      this.mixExportarDocumentosPdf(this.getContrato.numero);
    },
  },
  computed: {
    getExistenDocumentos() {
      if (!this.expedientePorContrato) return false;
      return this.expedientePorContrato.length > 0;
    },
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getCatalogoExpediente() {
      if (!this.catalogoExpediente) return [];
      return this.catalogoExpediente
        .slice()
        .sort((a, b) => (a.orden - b.orden));
    },
    getDocumentosExpedienteContrato() {
      if (!this.expedientePorContrato) return [];
      return this.expedientePorContrato
        .filter((documentoExpediente) => {
          if (!this.buscarTexto) return documentoExpediente;
          const expt = new RegExp(this.buscarTexto, 'gi');
          const descripcion = this.$normalizacionTexto(
            documentoExpediente.documento.descripcion,
          );
          const referencia = this.$normalizacionTexto(
            documentoExpediente.referencia,
          );
          return (
            expt.test(descripcion)
            || expt.test(referencia)
            || expt.test(documentoExpediente.documento.descripcion)
            || expt.test(documentoExpediente.referencia)
          );
        })
        .sort((a, b) => a.referencia.localeCompare(b.referencia))
        .sort((a, b) => a.documento.orden - b.documento.orden);
    },
    getEstadisticas() {
      if (!this.expedientePorContrato) {
        return {
          documentosTotales: 0,
          documentosAplican: 0,
          documentosFaltantes: 0,
          documentosIntegrados: 0,
        };
      }
      const documentosTotales = this.expedientePorContrato.length;
      let documentosAplican = 0;
      let documentosFaltantes = 0;
      let documentosIntegrados = 0;

      this.expedientePorContrato.forEach((doc) => {
        if (doc.aplica) documentosAplican += 1;
        if (!doc.existe && doc.aplica) documentosFaltantes += 1;
        if (doc.publicKey) documentosIntegrados += 1;
      });

      return {
        documentosTotales,
        documentosAplican,
        documentosFaltantes,
        documentosIntegrados,
      };
    },
    getPorcentajeIntegracion() {
      const { documentosAplican, documentosIntegrados } = this.getEstadisticas;
      if (documentosAplican === 0) return 0;
      return (documentosIntegrados / documentosAplican) * 100;
    },
    getColorProgreso() {
      const porcentaje = this.getPorcentajeIntegracion;
      if (porcentaje >= 100) return 'success';
      if (porcentaje >= 75) return 'info';
      if (porcentaje >= 50) return 'warning';
      return 'error';
    },
    getTextoEstadoExpediente() {
      const porcentaje = this.getPorcentajeIntegracion;
      if (porcentaje >= 100) return 'Expediente completo';
      if (porcentaje >= 75) return 'Casi completo';
      if (porcentaje >= 50) return 'En progreso';
      if (porcentaje > 0) return 'Parcialmente integrado';
      return 'Sin integrar';
    },
    getSoloPublicKeys() {
      if (!this.expedientePorContrato) return [];
      return this.expedientePorContrato
        .filter(({ publicKey, aplica }) => publicKey && aplica)
        .map(({ publicKey }) => publicKey);
    },
    estructuraZip() {
      if (!this.expedientePorContrato) return {};
      return this.expedientePorContrato
        .filter(({ publicKey, aplica }) => publicKey && aplica)
        .reduce((estructura, documentoExpediente) => {
          const etapa = documentoExpediente.etapa || 'Sin etapa';
          const orden = documentoExpediente.documento?.orden || 'NA';
          const descripcion = documentoExpediente.documento?.descripcion || 'Documento';
          const referencia = documentoExpediente.referencia
            ? `_${documentoExpediente.referencia}`
            : '';

          return {
            ...estructura,
            [documentoExpediente.publicKey]: {
              carpeta: etapa,
              nombre: `${etapa}_${orden}_${this.getContrato.numero}_${descripcion}${referencia}`,
            },
          };
        }, {});
    },
  },
  mounted() {
    eventBus.$on('agregar-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarAgregarDocumentoExpediente = true;
    });
    eventBus.$on('editar-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarEditarDocumentoExpediente = true;
    });
    eventBus.$on('borrar-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarEliminarDocumetoExpediente = true;
    });
    eventBus.$on('ver-documento-expediente', (documentoExpediente) => {
      this.esteDocumentoExpediente = documentoExpediente;
      this.mostrarVerDocumentoExpediente = true;
    });
  },
};
</script>

<style lang="scss">
</style>
